import { useEffect, useState, Fragment} from 'react';
import { getSession } from 'next-auth/client';
import { isMobileOnly } from 'react-device-detect';
import { Container, Column, ArticleHeader, ArticleSummary, Bulletin, MobileInsertAd, LoadMoreSection, Seo } from '@app/components';
import { linkHelper, getTopic, useSelectedFilters } from '@app/utils';

export async function getServerSideProps(context) {
  const { params } = context;
  let session = await getSession(context);
  const result = await getTopic([params.id])

  if (!result || result?.status !==200) {
    return {
      notFound: true,
    }
  }

  let {data} = result;

  if( !data?.summary && !params?.slug){
    return {
      notFound: true,
    };
  }else if(data?.summary?.slug!==params.slug){
    return {
      redirect: {
        destination: linkHelper("topic", data.summary.slug, params.id),
        permanent: false,
      }
    }
  }

  return {
    props: {
      params,
      data: data,
      session: session
    }
  }
  
}

export default function Topic({ params, data, session }) {
  let { items, paging, summary, filter } = data;
  let { tags } = summary;
  const selectedFilters = useSelectedFilters(filter)
  const [itemTypes, setItemTypes] = useState();
  
  if(paging) {
    paging.start = 12
  }

  useEffect(() => {
    if(selectedFilters?.itemTypes)
      setItemTypes(selectedFilters.itemTypes)
  }, [selectedFilters])

  const MainSection = () => <>
    <ArticleHeader {...summary} />
    <div className='lg:tw-mt-2 | 2xl:tw-mt-10'>
      {items.map((item, i) =>
        <Fragment key={i}>
          {!(i === 0) && Number.isInteger(i / paging.rows * 2) ? <MobileInsertAd googleAd /> : ''}
          {isMobileOnly ? <ArticleSummary {...item} columnProps={{skipBorder: '8n'}} />
            : <ArticleSummary {...item} />}
        </Fragment>
      )}
    </div>
  </>

  return <>
    <Seo.Topics data={data} summary={summary} />
    <Container googleAd center={<MainSection />} left={<div className='sm:tw-hidden 2xl:tw-block'><Bulletin /></div>} />
    {itemTypes && paging?.hasNext && 
      <LoadMoreSection googleAd key={`topic-load-more-${params.id}`} pagingData={paging} queries={{itemTypes:itemTypes,tags:tags}} id={params.id} func={`topic`} />
    }
    
  </>

  
}
